import React, { createContext, useCallback, useContext, useMemo } from 'react';

import { hasExportPermission as checkExportPermission, hasPermissionCode, permissionForRoute } from '../config/permissions';

const AuthContext = createContext(null);

export function AuthProvider({ auth, setAuth, children }) {
  const hasPermission = useCallback(
    (code) => hasPermissionCode(auth?.permissions, code),
    [auth?.permissions]
  );

  const canAccessRoute = useCallback(
    (pathSlug) => hasPermission(permissionForRoute(pathSlug)),
    [hasPermission]
  );

  const hasExportPermission = useCallback(
    (slug) => checkExportPermission(auth?.permissions, slug),
    [auth?.permissions]
  );

  const value = useMemo(
    () => ({
      auth,
      setAuth,
      hasPermission,
      hasExportPermission,
      canAccessRoute,
      username: auth?.username || '',
      roles: auth?.roles || [],
      roleLabels: auth?.role_labels || [],
      permissions: auth?.permissions || [],
      totpEnabled: Boolean(auth?.totp_enabled),
    }),
    [auth, setAuth, hasPermission, hasExportPermission, canAccessRoute]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error('useAuth AuthProvider içinde kullanılmalı');
  }
  return ctx;
}
